import * as React from 'react';
import { FieldsetDataHooks, FieldsetProps } from './types';
import { classes, st } from './Fieldset.st.css';
import { ErrorSmall } from '@wix/wix-ui-icons-common/on-stage';
import { Asterisk } from '../Asterisk/Asterisk';

export const Fieldset = React.forwardRef<HTMLFieldSetElement, FieldsetProps>(
  (
    {
      children,
      label,
      errorMessage,
      labelId,
      errorMessageId,
      dataHook,
      className,
      showLabelAsterisk,
      onLabelClick,
      ...props
    },
    ref,
  ) => {
    return (
      <fieldset
        className={st(
          classes.root,
          {
            error: Boolean(errorMessage),
          },
          className,
        )}
        data-hook={dataHook}
        ref={ref}
        {...props}
      >
        {label && (
          <legend
            id={labelId}
            className={classes.label}
            onClick={onLabelClick}
            data-hook={FieldsetDataHooks.Label}
          >
            {label}
            {showLabelAsterisk && (
              <Asterisk dataHook={FieldsetDataHooks.LabelAsterisk} />
            )}
          </legend>
        )}
        {children}
        {errorMessage && (
          <div
            className={classes.error}
            id={errorMessageId}
            data-hook={FieldsetDataHooks.Error}
          >
            <ErrorSmall aria-hidden className={classes.errorIcon} />
            {errorMessage}
          </div>
        )}
      </fieldset>
    );
  },
);
